"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RContext = void 0;
var react_1 = __importDefault(require("react"));
exports.RContext = react_1.default.createContext({});
//# sourceMappingURL=context.js.map